import React from 'react';
import { Badge, Box, Button, HStack, Text, useColorModeValue } from '@chakra-ui/react';

const TourModeBanner = ({ isTourMode = false, organization }) => {
  const bg = useColorModeValue('blue.50', 'blue.900');
  const borderColor = useColorModeValue('blue.100', 'blue.700');
  const badgeBg = useColorModeValue('blue.100', 'blue.800');
  const textColor = useColorModeValue('blue.800', 'blue.100');
  const mutedColor = useColorModeValue('blue.700', 'blue.200');

  if (!isTourMode) {
    return null;
  }

  return (
    <Box
      px={{ base: 4, md: 6 }}
      py={3}
      bg={bg}
      borderBottomWidth="1px"
      borderColor={borderColor}
      position="relative"
      zIndex="1001"
    >
      <HStack spacing={3} flexWrap="wrap" justify="space-between">
        <HStack spacing={3} flexWrap="wrap">
          <Badge bg={badgeBg} color={textColor} px={2.5} py={1} borderRadius="full">
            Tour Mode
          </Badge>
          <Text color={textColor} fontSize="sm" fontWeight="medium">
            Tour Mode Active
          </Text>
          <Text color={mutedColor} fontSize="sm">
            You are viewing a demo organization. Changes will not be saved.
          </Text>
        </HStack>
        <Button size="sm" colorScheme="blue">
          Activate School
        </Button>
      </HStack>
    </Box>
  );
};

export default TourModeBanner;
